/** @jsx h */
import { h } from 'preact'

import BlockchainProof from './BlockchainProofSection'
import ClaimsSection from './ClaimsSection'
import CollaboratorActivity from './CollaboratorActivity'
import Footer from './Footer'
import LocationSection from './LocationSection'
import ModalCardHeader from './Header'
import { ProofPointStickyHeader } from './StickyHeader'
import Feedback from '../feedback/Feedback'
import NetworkVerification from './NetworkVerificationSection'

const ModalConnectionCard = ({
  activity,
  collaborator,
  organization,
  networkExplorerUrl,
  location,
  ipfsHash,
  claimStatus
}) => {
  const { name, avatarUrl, claims, href } = collaborator
  const theLocation = location || collaborator.location

  return (
    <article
      class='ClaimCard'
    >
      <ProofPointStickyHeader
        title={name}
        type='Connection'
        logoUrl={avatarUrl}
      />
      <div class='ModalCard-content'>
        <ModalCardHeader title={name} imageUrl={avatarUrl} variant='user' claimStatus={claimStatus} />
        <CollaboratorActivity description={activity} />
        {claims && claims.length > 0 && <ClaimsSection claims={claims} />}
        {theLocation && <LocationSection {...theLocation} />}
        <NetworkVerification
          name={name}
          url={href}
          organizationName={organization.name}
        />
        {networkExplorerUrl &&
          <BlockchainProof
            url={networkExplorerUrl}
            hash={ipfsHash}
          />}
        <Footer>
          <Feedback
            context='Connection'
            organizationName={organization.name}
            analyticsName={name}
          />
        </Footer>
      </div>
    </article>
  )
}

ModalConnectionCard.defaultProps = {
  location: null
}

export default ModalConnectionCard
